var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-link',{attrs:{"to":"/"}},[_vm._v("Go to Home page")]),_vm._v(" "),_c('h1',[_vm._v("About page")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }